import { put, call, getContext } from "redux-saga/effects";

import { claimList } from "../../Services/ClaimCashless";

export function* claimListSaga(action) {
  const store = yield getContext("store");

  const { payload } = action;
  try {
    const res = yield call(
      claimList,
      payload

      //   (percent) => {
      //     store.dispatch({
      //       type: "REQ_CLAIM_LIST_PROGRESS",
      //       progress: percent,
      //     });
      //   }
    );

    yield put({ type: "REQ_CLAIM_LIST_SUCCESS", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_CLAIM_LIST_FAILED", errData: e });
  }
}
